module.exports = __webpack_public_path__ + "static/media/tangent1.f44abdfe.jpg";